import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomers, StateStatus } from '@guryou/redux';

import { resetState } from '../actions';
import { CUSTOMERS_GET_MANY } from '../types';

const useClients = (stateSelector, noWlakinClients = false, rs = true, notArchived = null, active = null, isApproved = null) => {
  const dispatch = useDispatch();
  const { data, status, version, entity, request } = useSelector(stateSelector);
  const clients = Array.isArray(data) ? data : [];

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED || (status === StateStatus.LOADED && !Array.isArray(data))) {
      dispatch(getCustomers(notArchived, active, isApproved));
    }
  }, [active, data, dispatch, isApproved, notArchived, status]);

  useEffect(() => {
    return () => rs && dispatch(resetState(CUSTOMERS_GET_MANY));
  }, [dispatch, rs]);

  if (noWlakinClients) {
    return { data: clients.filter(x => x?.id && (x?.id !== null || x?.id !== undefined)), status, version, entity, request };
  }
  return { data: clients, status, version, entity, request };
};

export default useClients;
